

























import Vue from "vue";
import { authService } from "@/common/services/AuthService";
import FirebaseSignIn from "@/common/components/FirebaseSignIn.vue";
import ReceiptsTable, { ReceiptTableOptions } from "@/receipts/components/ReceiptsTable.vue";
import ReceiptDialog from "@/receipts/components/ReceiptDialog.vue";
import Scaffold from "@/Scaffold.vue";
import { storeService } from "@/common/services/StoreService";
import { AdminStore } from "@/common/models/AdminStore";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";
import { assertNotNull } from "@/common/utils/Utils";
import { AdminReceipt, AdminReceiptListItem } from "@/common/models/Receipt";

export default Vue.extend({
  name: "StoreReceipts",
  components: {
    FirebaseSignIn,
    ReceiptsTable,
    ReceiptDialog,
    Scaffold,
  },

  data() {
    return {
      selectedStore: null as AdminStore | null,
      items: [] as AdminReceiptListItem[],
      totalItems: 0 as number,
      loading: true as boolean,
      loadingReceipt: false as boolean,
      receipt: null as AdminReceipt | null,
      options: {
        page: 1,
        itemsPerPage: 10,
      } as ReceiptTableOptions,
      authService: authService,
      storeService: storeService,
    };
  },
  computed: {
    breadcrumbs(): Array<Record<string, string | boolean>> {
      return [
        {
          text: "Home",
          to: "/",
        },
        {
          text: this.selectedStore?.name ?? "",
          to: `/stores/${this.storeService.selectedStore}`,
        },
        {
          text: "Receipts",
          disabled: true,
        },
      ];
    },
    currentStore(): string {
      return this.storeService.selectedStore;
    },
  },
  watch: {
    currentStore: function (): void {
      this.setSelectedStore();
    },
    options: {
      handler(): void {
        this.fetchReceipts();
      },
      deep: true,
    },
  },
  async beforeMount() {
    this.storeService.selectedStore = this.$route.query.storeId as string;
    await this.setSelectedStore();
  },
  methods: {
    async setSelectedStore(): Promise<void> {
      const result = await storeService.getAdminStoreById(storeService.selectedStore);
      if (result) {
        if (this.selectedStore?.id !== result.id) {
          await this.$router
            .push({
              name: RouteInfoMap.get(Paths.StoreReceipts)?.name,
              query: {
                storeId: assertNotNull(result).id.toString(),
              },
            })
            .catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          this.selectedStore = result;
          await this.fetchReceipts();
        }
      } else {
        this.selectedStore = null;
      }
    },
    async fetchReceipts(): Promise<void> {
      const { page, itemsPerPage } = this.options;

      try {
        this.loading = true;
        const response = await this.storeService.getReceipts(
          this.options.storeId as string,
          this.options.userId,
          this.options.from,
          this.options.to,
          (page - 1) * itemsPerPage,
          itemsPerPage
        );
        this.items = response.items;
        this.totalItems = response.total ?? Infinity;
      } catch (error: any) {
        console.error("Failed to fetch receipts", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchReceipt(receiptId: string): Promise<void> {
      try {
        this.loadingReceipt = true;
        this.receipt = await this.storeService.getReceipt(this.options.storeId as string, receiptId);
      } catch (error: any) {
        console.error("Failed to fetch receipt", error);
      } finally {
        this.loadingReceipt = false;
      }
    },
    closeReceipt(): void {
      this.receipt = null;
    },
  },
});
